import React from 'react';
import {
    StyledCookieConsentTextArea,
    StyledCookieConsentHeader,
    StyledCookieConsentParagraph,
    StyledCookieConsentDescription,
} from '../CookieConsent.styles';
import { Divider, InfoList, InfoListItem, InfoListSvg } from '../CookieSetting/CookieSetting.styles';
import ExternalLink from '../../ExternalLink/ExternalLink';

const IconMarketing = () => (
    <InfoListSvg
        aria-hidden="true"
        width="28"
        height="21"
        viewBox="0 0 28 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M25.0094 17.961V7.94471H20.0312V17.961H25.0094ZM26.2389 5.48563C26.5513 5.48563 26.8441 5.61266 27.1173 5.86673C27.3906 6.12081 27.5272 6.40403 27.5272 6.71642V19.1917C27.5272 19.5041 27.3906 19.7969 27.1173 20.0702C26.8441 20.3434 26.5513 20.48 26.2389 20.48H18.7417C18.4293 20.48 18.1461 20.3434 17.892 20.0702C17.638 19.7969 17.5109 19.5041 17.5109 19.1917V6.71642C17.5109 6.40403 17.638 6.12081 17.892 5.86673C18.1461 5.61266 18.4293 5.48563 18.7417 5.48563H26.2389ZM12.5341 17.3162C13.0414 17.3162 13.4808 17.1308 13.8523 16.7602C14.2238 16.3895 14.4092 15.95 14.4084 15.4419C14.4075 14.9338 14.2222 14.4943 13.8523 14.1236C13.4825 13.7529 13.043 13.5676 12.5341 13.5676C12.0251 13.5676 11.5857 13.7529 11.2158 14.1236C10.8459 14.4943 10.6606 14.9338 10.6598 15.4419C10.6589 15.95 10.8443 16.3895 11.2158 16.7602C11.5873 17.1308 12.0267 17.3162 12.5341 17.3162ZM14.9931 10.4638V12.6892C15.852 13.4706 16.2814 14.3881 16.2814 15.4419C16.2814 16.5357 15.852 17.4728 14.9931 18.2533V20.4788H10.015V18.2533C9.19531 17.5111 8.78546 16.574 8.78546 15.4419C8.78546 14.3481 9.19531 13.4306 10.015 12.6892V10.4638H14.9931ZM2.51781 2.96657V17.961H7.49594V20.48H2.51781C1.85389 20.48 1.26828 20.2264 0.760965 19.719C0.253655 19.2117 0 18.6261 0 17.9622V2.96782C0 2.3039 0.253655 1.71829 0.760965 1.21098C1.26828 0.703667 1.85389 0.450012 2.51781 0.450012H25.0094V2.96907H2.51781V2.96657Z"
            fill="#FEF8C5"
        />
    </InfoListSvg>
);

const IconPersonalized = () => (
    <InfoListSvg
        aria-hidden="true"
        width="27"
        height="18"
        viewBox="0 0 27 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M18.2238 10.1305C19.2873 10.1305 20.4451 10.2824 21.6973 10.5861C22.9494 10.8898 24.1073 11.3835 25.1707 12.0671C26.2342 12.7507 26.7659 13.529 26.7659 14.4022V17.42H19.4764V14.4022C19.4764 12.7312 18.679 11.3264 17.0842 10.1876C17.3499 10.1495 17.7297 10.1305 18.2238 10.1305ZM8.54332 10.1305C9.60678 10.1305 10.7646 10.2824 12.0168 10.5861C13.269 10.8898 14.4175 11.3835 15.4623 12.0671C16.5071 12.7507 17.0291 13.529 17.0283 14.4022V17.42H0V14.4022C0 13.529 0.53173 12.7507 1.59519 12.0671C2.65865 11.3835 3.81647 10.8898 5.06865 10.5861C6.32083 10.2824 7.47864 10.1305 8.5421 10.1305H8.54332ZM8.54332 7.73953C7.55599 7.73953 6.70191 7.3787 5.98105 6.65704C5.2602 5.93538 4.89937 5.08129 4.89856 4.09477C4.89775 3.10826 5.25858 2.25417 5.98105 1.53251C6.70353 0.810844 7.55761 0.450012 8.54332 0.450012C9.52902 0.450012 10.3738 0.810844 11.0776 1.53251C11.7815 2.25417 12.1326 3.10826 12.131 4.09477C12.1294 5.08129 11.7782 5.93538 11.0776 6.65704C10.377 7.3787 9.53226 7.73953 8.54332 7.73953ZM18.2238 7.73953C17.2365 7.73953 16.3824 7.3787 15.6615 6.65704C14.9407 5.93538 14.5799 5.08129 14.579 4.09477C14.5782 3.10826 14.9391 2.25417 15.6615 1.53251C16.384 0.810844 17.2381 0.450012 18.2238 0.450012C19.2095 0.450012 20.0636 0.810844 20.7861 1.53251C21.5085 2.25417 21.8694 3.10826 21.8686 4.09477C21.8678 5.08129 21.5069 5.93538 20.7861 6.65704C20.0652 7.3787 19.2111 7.73953 18.2238 7.73953Z"
            fill="#FEF8C5"
        />
    </InfoListSvg>
);

const IconImproved = () => (
    <InfoListSvg
        aria-hidden="true"
        width="18"
        height="25"
        viewBox="0 0 18 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8.55162 0C10.9238 0 12.9421 0.832224 14.6066 2.49667C16.271 4.16112 17.1032 6.17944 17.1032 8.55162C17.1032 11.4218 15.8788 13.756 13.4299 15.5543V18.3669C13.4299 18.7114 13.3152 18.9983 13.0858 19.2277C12.8564 19.4571 12.5695 19.5718 12.225 19.5718H4.87824C4.53376 19.5718 4.24683 19.4571 4.01745 19.2277C3.78807 18.9983 3.67338 18.7114 3.67338 18.3669V15.5543C1.22446 13.8703 0 11.536 0 8.55162C0 6.17944 0.832224 4.16112 2.49667 2.49667C4.16112 0.832224 6.17944 0 8.55162 0ZM4.87824 23.2451V22.0403H12.225V23.2451C12.225 23.5896 12.1103 23.8765 11.8809 24.1059C11.6515 24.3353 11.3646 24.45 11.0201 24.45H6.08433C5.73985 24.45 5.45292 24.3353 5.22354 24.1059C4.99416 23.8765 4.87947 23.5896 4.87947 23.2451H4.87824Z"
            fill="#FEF8C5"
        />
    </InfoListSvg>
);

const CookieContentInfo = () => (
    <StyledCookieConsentTextArea>
        <StyledCookieConsentHeader id="cookie-header">
            Vi vill ge dig en bättre upplevelse
        </StyledCookieConsentHeader>
        <StyledCookieConsentDescription>
            Vissa kakor är nödvändiga för att tjänsten ska fungera. De som du kan välja används för att:
        </StyledCookieConsentDescription>
        <InfoList>
            <InfoListItem>
                <IconImproved /> Utveckla och förbättra SVT Play
            </InfoListItem>
            <InfoListItem>
                <IconPersonalized /> Anpassa innehåll och funktioner för dig
            </InfoListItem>
            <InfoListItem>
                <IconMarketing /> Tipsa dig om våra program på andra webbplatser
            </InfoListItem>
        </InfoList>
        <Divider />
        <StyledCookieConsentParagraph>
            Vissa cookies kommer från företag vi samarbetar med. Du kan när som helst ändra eller återkalla
            ditt medgivande.{' '}
            <ExternalLink href="https://kontakt.svt.se/guide/cookies-och-personuppgifter">
                Om cookies och personuppgifter
            </ExternalLink>
            .
        </StyledCookieConsentParagraph>
    </StyledCookieConsentTextArea>
);

export default CookieContentInfo;
